import {Component, Input, OnInit} from '@angular/core';
import {AdfiGraphqlService} from '@services/adfi-graphql.service';
import {AdfiGrowlService} from '@services/adfi-growl.service';
import {NAME_ENTITY, NAME_MONTHS, QUARTER_RANGES} from '../../../config/constants';
import moment from 'moment';
import { AdfiService } from '@services/adfi-service';
import { PeriodState } from '@Interfaces/index';


interface CalendarDate {
  date: moment.Moment;
  events: CalendarEvent[];
}

interface CalendarEvent {
  title: string;
  roleId?: string | number;
  policyHolderId?: string | number;
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  constructor(private graphql: AdfiGraphqlService, private growl: AdfiGrowlService, private adfiService: AdfiService) {
  }

  /**
   * list of dates
   */
  listDates: Map< string, CalendarDate> = new Map<string, CalendarDate>();
  listDatesTraining: Map< string, CalendarDate> = new Map<string, CalendarDate>();
  listDatesSifse: Map< string, CalendarDate> = new Map<string, CalendarDate>();

  /**
   * State of loading dates
   */
  loadingDates = true;

  /**
   * State of loading dates trainings
   */
  loadedTraining = false;
  
  /**
   * State of loading dates sifse
   */
  loadedSifse = false;

  private loadingCounter = 0;
  private totalQueries = 3;

  @Input()
  period: number;

  /**
   * Range days into filter
   */
  DAYS_RANGE = 20;
  
  block : boolean;

  /**
   * Return text for display on calendar with month and entity name
   * @param entity entity name
   * @param month month number 1 - 12
   * @param monthEnd month number 1 - 12
   * @param action action of add in text
   * @param nitEnd digit with en nit
   * @private
   * @return text to display in list of dates
   */
  private getTextDate({entity, month, monthEnd, action, nitEnd, closingDate, roleId , policyHolderId}:
                                 {
                                   entity: string, month: number,
                                   monthEnd?: number, action?: string, nitEnd?: string,
                                   closingDate?: moment.Moment,
                                   roleId?: string | number,
                                   policyHolderId?: string | number
                                 }): string {
    if (entity === 'Policy') {
    const today = moment();
    const daysLeft = closingDate ? closingDate.diff(today, 'days') : 0;
    const roleText = roleId ? ` ${roleId}` : '';
    const policyHolder = policyHolderId ? ` ${policyHolderId}` : '';
    
    let dateText = '';
    if (daysLeft >= 0) {
      dateText = `vence en ${daysLeft} día(s)`;
    } else {
      dateText = `venció hace ${Math.abs(daysLeft)} día(s)`;
    }
    
    return `ATENCIÓN! La póliza del ${roleText} ${policyHolder} ${dateText}. Por favor, revise la sección de pólizas para más detalles.`;
  }        
    if (entity === 'SIFSE') {
      return `Fecha límite para el cargue de ${entity} acumulado de ${QUARTER_RANGES[month]}.`;
    }else if (entity === 'Reservation') {
      return "Fecha límite de inscripción a la Jornada de Trabajo Conjunto a través del Módulo de Capacitaciones de la Plataforma.";
    }else {
      return `Fecha límite para ${action ? action : 'el cargue'} de  ${NAME_ENTITY[entity] ? NAME_ENTITY[entity] : entity }${month ? ' del mes de ' : ''}
    ${month ? NAME_MONTHS[month - 1] : ''}${monthEnd ? ' a ' : ''}${monthEnd ? NAME_MONTHS[monthEnd - 1] : ''}${nitEnd ? ` para NITS terminados en ${nitEnd}` : ''}.`;
    }
  }

  ngOnInit(): void {
    this.loadDates();
    this.loadDatesTributes();
    this.block = this.adfiService.validPermission('BlockingPlatform', 'lock', PeriodState.NO_STATUS);
    this.getPolicyDates();
  }

  /**
   * Builds the calendar with list of dates
   * @param listDates list of important dates
   * @private
   */
  private buildCalendarDates(listDates: {closingDate: moment.Moment, entity: string, month: number, nitEnd?: string, roleId?: string|number, policyHolderId?: string|number}[]) {
  const currentYear = moment().year();

  listDates.forEach(value => {
    value.closingDate = moment(value.closingDate);

    const key = value.closingDate.format('YYYY-MM-DD');
    const title = this.getTextDate(value);

    if (!title) {
      return;
    }

    const objEvent = {
      title,
      roleId: value.roleId,
      policyHolderId: value.policyHolderId
    };

    if (value.entity === 'Reservation') {
      this.loadedTraining = true;
      if (this.listDatesTraining.has(key)) {
        this.listDatesTraining.get(key).events.push(objEvent);
      } else {
        this.listDatesTraining.set(key, { date: value.closingDate, events: [objEvent] });
      }
    } else if (value.entity === 'SIFSE') {
      this.loadedSifse = true;
      if (this.listDatesSifse.has(key)) {
        this.listDatesSifse.get(key).events.push(objEvent);
      } else {
        this.listDatesSifse.set(key, { date: value.closingDate, events: [objEvent] });
      }
    } else {
      const addCalendar = this.validateNit(value.nitEnd);
      if (this.listDates.has(key) && addCalendar) {
        this.listDates.get(key).events.push(objEvent);
      } else if (addCalendar) {
        this.listDates.set(key, {
          date: value.closingDate,
          events: [objEvent]
        });
      }
    }
  });

  this.listDates = new Map([...this.listDates.entries()].sort());
  this.listDatesTraining = new Map([...this.listDatesTraining.entries()].sort());
  this.listDatesSifse = new Map([...this.listDatesSifse.entries()].sort());
}

  /**
   * Validate if nit cencos user ends with digit nit or in range 
   * @param nit last digit nit validate or range example 0, 0-5
   */
  private validateNit(nit?: string) {
    if(!nit) return true;
    if(String(this.adfiService.user.centroCosto.nit).endsWith(nit)) return true;
    if(nit.includes('-')){ // for 0-5
      const first = nit.substring(0, nit.indexOf('-'));
      const last = nit.substring(nit.indexOf('-')+1,nit.length);
      const nitCenter = this.adfiService.user.centroCosto.nit;      
      return Number(first) <= Number(nitCenter.substr(nitCenter.length - 1)) && Number(last) >= Number(nitCenter.substr(nitCenter.length - 1));
    }
    return false;
  }
  private completeLoading(): void {
    this.loadingCounter++;
    if (this.loadingCounter >= this.totalQueries) {
      this.loadingDates = false;
    }
  }

  private loadDatesTributes() {
    const next = (data) => {
      this.completeLoading();
      this.buildCalendarDates(data.map(value => ({
          closingDate: value.endDate,
          entity: value.dateTribute.tribute.nameTribute,
          month: value.dateTribute.monthTribute,
          monthEnd: value.dateTribute.monthEnd,
          action: value.dateTribute.optionalText ? value.dateTribute.optionalText : 'pago',
          nitEnd: value.nitEnd
      })));
    };
    const error = (e) => {
      this.growl.errorMessage(e);
    };
    this.graphql.getEntityWithOutIds('nitTributes',
        'dateTribute{tribute{nameTribute} optionalText monthTribute monthEnd} nitEnd endDate', 20,
        `order:{endDate:"ASC"},
                endDate: {after:"${(new Date()).toUTCString()}", before:"${(new Date((new Date()).setDate((new Date()).getDate() + this.DAYS_RANGE))).toUTCString()}"}`,
        {next, error});

  }

  /**
   * Loads the list of important dates
   * @private
   */
  private loadDates() {
    const next = (data) => {
      this.completeLoading();
      this.buildCalendarDates(data);
    };
    const error = (e) => {
      this.growl.errorMessage(e);
    };
    this.graphql.getEntityWithOutIds(
      'availableDates',
      'entity month closingDate appliesFiveDays',
      20,
      `entity_list: ["ExtractBankByAccount", "ALL","SIFSE", "Reservation"], order:{closingDate:"ASC"},
        closingDate: {after:"${(new Date()).toUTCString()}", before:"${(new Date((new Date()).setDate((new Date()).getDate() + this.DAYS_RANGE))).toUTCString()}"}`
      ,
      {next, error}
    );
  }

  
private getPolicyDates(): void {
  const cols = 'id endDate roleEmplPolicy{id name} policyHolder{id name}';

  this.graphql.getEntityWithOutIds(
    'policyByCenters',
    cols,
    10,
    `cencos: ${this.adfiService.user.centroCosto._id}`,
    {
      next: (data) => {
        try {
          const today = moment();

          const policiesByRole = new Map<string, {
            closingDate: moment.Moment;
            entity: string;
            month: number;
            roleId?: string | number;
            policyHolderId?: string | number;
          }>();

          data.forEach((policy) => {
            const startDate = moment(policy.startDate);
            const endDate = moment(policy.endDate);

            const isActive = startDate.isSameOrBefore(today, 'day') && endDate.isSameOrAfter(today, 'day');

            if (!isActive) {
              return;
            }

            const roleId = policy.roleEmplPolicy?.name;
            const policyKey = String(roleId || policy.policyHolder?.name || policy.id);
            const currentPolicy = policiesByRole.get(policyKey);

            if (!currentPolicy || endDate.isAfter(currentPolicy.closingDate)) {
              policiesByRole.set(policyKey, {
                closingDate: endDate,
                entity: 'Policy',
                month: endDate.month() + 1,
                roleId: policy.roleEmplPolicy?.name,
                policyHolderId: policy.policyHolder?.name
              });
            }
          });

      const policiesToAdd = Array.from(policiesByRole.values()).filter((policy) => {
      const daysLeft = policy.closingDate.diff(today, 'days');
      const allowed = daysLeft >= -20 && daysLeft <= 20;

      return allowed;
      });


          if (policiesToAdd.length > 0) {
            this.buildCalendarDates(policiesToAdd);
          }
        } finally {
          this.completeLoading();
        }
      },
      error: () => this.completeLoading()
    }
  );
}
}
